import React, { useState, useContext, useEffect } from "react";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import useApi from "../Api/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import SideLabelInput from "../Components/SideLabelInput";
import Button from "../Components/Button";
import StatesList from "../Components/StatesList";
import { FilterContext } from "../FilterContextProvider";

const AddEvent = ({ handleShowEventForm, fromHome }) => {
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const { filterData, setFilterData } = useContext(FilterContext);
  const [categories, setCategories] = useState([]);
  const history = useHistory();
  const api = useApi();
  const [artists, setArtists] = useState([]);
  const [eventTypes, setEventTypes] = useState([]);
  const [event, setEvent] = useState({
    date: "",
    name: "",
    capacity: "",
    attendance: "",
    type: "",
    city: "",
    state: "",
    zip_code: "",
    tax_rate: "",
    currency_exchange_rate: "",
    venue_rep_name: "",
    venue_rep_email: "",
    venue_rep_phone: "",
    artist_id: filterData.artist_id,
    event_type_id: "",
  });

  const [clothingSetup, setClothingSetup] = useState({
    hall_rate: "",
    name: "Clothing",
    category_id: "",
    event_id: "",
  });

  const [otherSetup, setOtherSetup] = useState({
    hall_rate: "",
    name: "Other",
    category_id: "",
    event_id: "",
  });

  const [musicSetup, setMusicSetup] = useState({
    hall_rate: "",
    name: "Music",
    category_id: "",
    event_id: "",
  });

  const artistOptions = artists.map((artist) => ({
    label: artist.name,
    value: artist.id,
  }));

  const categoryOptions = categories.map((category) => ({
    label: category.name,
    value: category.id,
  }));

  const stateOptions = StatesList.map((state) => ({
    label: state.name,
    value: state.abbreviation,
  }));

  const eventTypeOptions = eventTypes.map(({ id, name }) => ({
    label: name,
    value: id,
  }));

  const handleInputChange = ({ target: { id, value } }) => {
    setEvent({
      ...event,
      [id]: value,
    });
  };

  const handleHallRateChange = ({ target: { id, value } }) => {
    switch (id) {
      case "clothing_hall_rate":
        return setClothingSetup({
          ...clothingSetup,
          hall_rate: value,
        });
      case "other_hall_rate":
        return setOtherSetup({
          ...otherSetup,
          hall_rate: value,
        });
      case "music_hall_rate":
        return setMusicSetup({
          ...musicSetup,
          hall_rate: value,
        });
      default:
    }
  };

  const handleSelect = (option, name) => {
    setEvent({
      ...event,
      [name.name]: option.value,
    });
  };

  const handleArtistSelect = (option) => {
    setEvent({ ...event, artist_id: option.value });
    setFilterData({
      ...filterData,
      artist_id: option.value,
      artist_name: option.label,
    });
  };

  let hallRatesToSave = [];

  const handleSubmit = (e) => {
    setIsFetching(true);
    event.tax_rate = event.tax_rate / 100;
    clothingSetup.hall_rate = clothingSetup.hall_rate / 100;
    otherSetup.hall_rate = otherSetup.hall_rate / 100;
    musicSetup.hall_rate = musicSetup.hall_rate / 100;
    clothingSetup.category_id = categoryOptions.find(
      ({ label }) => "Clothing" === label
    ).value;
    otherSetup.category_id = categoryOptions.find(
      ({ label }) => "Other" === label
    ).value;
    musicSetup.category_id = categoryOptions.find(
      ({ label }) => "Music" === label
    ).value;
    hallRatesToSave.push(clothingSetup, otherSetup, musicSetup);
    api
      .post("/events", {
        event: {
          ...event,
          event_category_setups_attributes: hallRatesToSave.map((each) => ({
            hall_rate: each.hall_rate,
            name: each.name,
            category_id: each.category_id,
          })),
        },
      })
      .then((response) => {
        NotificationManager.success(
          "Event successfully added",
          "Success",
          2000
        );
        setFilterData({
          ...filterData,
          event_id: response.data.id,
        });
        history.push(`/sales/events/${response.data.id}/details`);
        return response.data;
      })
      .catch((error) => {
        setErrorMessage(error.response.data);
        setIsFetching(false);
      })
      .finally(() => {});
    e.preventDefault();
  };

  useEffect(() => {
    api.get(`/artists`).then((r) => {
      setArtists(r.data);
    });
    api.get(`/categories`).then((r) => {
      setCategories(r.data);
    });
    api.get(`/event_types`).then((r) => {
      setEventTypes(r.data);
    });
  }, [api]);

  return (
    <div
      className={
        fromHome
          ? "-mt-28 side-modal"
          : "-mt-18 side-modal"
      }
    >
      <div className="flex-col">
        <header className="py-6 px-4 text-lg mb-2 bg-blue-500 text-white">
          <button onClick={handleShowEventForm} className="float-right -mt-4">
            <FontAwesomeIcon icon={faTimes}></FontAwesomeIcon>
          </button>
          <div>
            New Event
            {filterData.artist_name && (
              <>
                {" "}
                for
                <span className="font-bold"> {filterData.artist_name}</span>
              </>
            )}
          </div>
          <div className="text-sm">
            You can modify this information later if needed
          </div>
        </header>
        <div className="mt-8 px-4 tracking-normal	font-medium text-lg">
          Event Information
        </div>
        <hr className="my-3 mx-4"></hr>
        <form className="mx-4 text-xs" id="submit" onSubmit={handleSubmit}>
          {fromHome && (
            <>
              <div className="h-8 flex items-center">
                <label htmlFor="artist" className="w-1/3">
                  Artist *
                </label>
                <div className="w-full ml-5">
                  <Select
                    id="artist"
                    name="artist_id"
                    placeholder="Select an artist"
                    options={artistOptions}
                    value={artistOptions?.filter(
                      (each) => each.value === filterData.artist_id
                    )}
                    onChange={(option) => handleArtistSelect(option)}
                  />
                </div>
              </div>
              <hr className="my-3"></hr>
            </>
          )}
          <div className="flex items-center">
            <label htmlFor="date" className="w-1/3">
              Date *
            </label>
            <input
              value={event.date}
              type="date"
              id="date"
              name="date"
              className="h-9 pl-2 ml-5 font-light rounded-md border w-full justify-self-end"
              onChange={handleInputChange}
              required
            ></input>
          </div>
          {errorMessage?.errors?.date && (
            <div className="text-red-500 pb-2">{errorMessage.errors.date}</div>
          )}
          <hr className="my-3"></hr>
          <div>
            <div>
              <SideLabelInput
                id="name"
                name="name"
                label="Venue *"
                value={event.name}
                onChange={handleInputChange}
                disabled={isFetching}
                required
              />
              {errorMessage?.errors?.name && (
                <div className="text-red-500 pb-2">
                  {errorMessage.errors.name}
                </div>
              )}
            </div>
            <hr className="my-3"></hr>
            <div>
              <SideLabelInput
                id="capacity"
                name="capacity"
                label="Capacity"
                value={event.capacity}
                onChange={handleInputChange}
                disabled={isFetching}
              />
            </div>
            <hr className="my-3"></hr>
            <div>
              <SideLabelInput
                id="attendance"
                name="attendance"
                label="Attendance"
                value={event.attendance}
                onChange={handleInputChange}
                disabled={isFetching}
              />
            </div>
            <hr className="my-3"></hr>
            <div className="h-8 flex items-center">
              <label htmlFor="event_type" className="w-1/3">
                Event Type
              </label>
              <div className="w-full ml-5">
                <Select
                  id="event_type"
                  name="event_type_id"
                  placeholder="Select Event Type"
                  options={eventTypeOptions}
                  value={eventTypeOptions?.filter(
                    (each) => each.value === event.event_type_id
                  )}
                  onChange={(option, name) => handleSelect(option, name)}
                  disabled={isFetching}
                />
              </div>
            </div>
            <hr className="my-3"></hr>
            <fieldset className="flex text-xs">
              <div className="w-1/3 self-center">
                <legend>Location</legend>
              </div>
              <div className="ml-5 flex w-full">
                <input
                  id="city"
                  placeholder="City"
                  value={event.city}
                  className="h-9 pl-2 rounded-md border w-1/2"
                  onChange={handleInputChange}
                  disabled={isFetching}
                />
                <div className="h-8 mx-2 w-1/4 max-h-1">
                  <Select
                    id="state"
                    name="state"
                    placeholder="State"
                    options={stateOptions}
                    value={stateOptions?.filter(
                      (each) => each.value === event.state
                    )}
                    onChange={(option, name) => handleSelect(option, name)}
                  />
                </div>
                <input
                  id="zip_code"
                  placeholder="Zip Code"
                  value={event.zip_code}
                  className="h-9 pl-2 rounded-md border w-1/4"
                  onChange={handleInputChange}
                  disabled={isFetching}
                />
              </div>
            </fieldset>
            <hr className="my-3"></hr>
            <fieldset className="flex text-xs mt-4">
              <div className="w-1/3 self-center">
                <legend>Fees </legend>
              </div>
              <div className="ml-5 flex w-full">
                <input
                  id="clothing_hall_rate"
                  name="clothing_hall_rate"
                  placeholder="Clothing Hall %"
                  value={clothingSetup.hall_rate}
                  className="h-9 pl-2 rounded-md border w-1/3"
                  onChange={handleHallRateChange}
                  disabled={isFetching}
                  required
                />
                <input
                  id="other_hall_rate"
                  name="other_hall_rate"
                  placeholder="Other %"
                  value={otherSetup.hall_rate}
                  className="h-9 pl-2 rounded-md border w-1/3 mx-2"
                  onChange={handleHallRateChange}
                  disabled={isFetching}
                  required
                />
                <input
                  id="music_hall_rate"
                  name="music_hall_rate"
                  placeholder="Music Hall %"
                  value={musicSetup.hall_rate}
                  className="h-9 pl-2 rounded-md border w-1/3"
                  onChange={handleHallRateChange}
                  disabled={isFetching}
                  required
                />
              </div>
            </fieldset>
            <hr className="my-3"></hr>
            <fieldset className="flex text-xs mt-4">
              <div className="w-1/3 self-center">
                <legend>Tax rate</legend>
              </div>
              <div className="ml-5 flex w-full">
                <input
                  id="tax_rate"
                  placeholder="%"
                  value={event.tax_rate}
                  className="h-9 pl-2 rounded-md border w-1/3 -mr-2"
                  onChange={handleInputChange}
                  disabled={isFetching}
                />
              </div>
            </fieldset>
            <hr className="my-3"></hr>
            <fieldset className="flex text-xs mt-4">
              <div className="w-1/3 self-center">
                <legend>Currency Exchange Rate</legend>
              </div>
              <div className="ml-5 flex w-full">
                <input
                  id="currency_exchange_rate"
                  type="number"
                  min="0"
                  step="0.00001"
                  placeholder="e.g. 0.72"
                  value={event.currency_exchange_rate}
                  className="h-9 pl-2 rounded-md border w-1/3 -mr-2"
                  onChange={handleInputChange}
                  disabled={isFetching}
                />
              </div>
            </fieldset>
            <hr className="my-3"></hr>
          </div>
          <div className="flex justify-center mt-8">
            {errorMessage?.error && (
              <div className="text-red-500 pb-2">{errorMessage.error}</div>
            )}
          </div>
          <div className="flex justify-end py-4 float-right">
            <Button
              text={isFetching ? `Loading ${"\u00A0"}` : "Save"}
              type="submit"
              form="submit"
              value="Submit"
              disabled={isFetching}
              inProgress={isFetching}
              className="button float-right"
            ></Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEvent;
